import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface PackageDimensionsCardProps {
  package_dimensions: {
    volume: number;
    name: string;
  }[];
}

export function PackageDimensionsCard({
  package_dimensions,
}: PackageDimensionsCardProps) {
  if (!package_dimensions?.length) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Package Dimensions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {package_dimensions.map((pkg, index) => (
            <div
              key={index}
              className="flex justify-between items-center p-3 bg-gray-50 rounded-lg"
            >
              <span className="font-medium">{pkg.name}</span>
              <span className="text-gray-600">{pkg.volume} m³</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
